"use strict";
/** @private */
/** @private*/
Object.defineProperty(exports, "__esModule", { value: true });
var Es6;
(function (Es6) {
    function strIncludes(haystack, needle) {
        return haystack.indexOf(needle) >= 0;
    }
    Es6.strIncludes = strIncludes;
    function arrIncludes(arr, v) {
        return arr.indexOf(v) >= 0;
    }
    Es6.arrIncludes = arrIncludes;
    function strRepeat(what, num) {
        let result = "";
        for (let i = 0; i < num; i++) {
            result += what;
        }
        return result;
    }
    Es6.strRepeat = strRepeat;
    function regexFlags(regex) {
        let flags = "";
        if (regex.global)
            flags += "g";
        if (regex.ignoreCase)
            flags += "i";
        if (regex.multiline)
            flags += "m";
        return flags;
    }
    Es6.regexFlags = regexFlags;
})(Es6 = exports.Es6 || (exports.Es6 = {}));
//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/parjs/common/common.js
// module id = 211
// module chunks = 0 1